module.exports = __webpack_public_path__ + "img/ico-union-pay.e561a612.svg";